import { ValuableNode } from '../../models/ValuableNode'

export class SchemaDateNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Date': SchemaDateNode
  }
}
